/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Billing_Board_Alltime_NoneInputs */



/**
* | output |
* | --- |
* | "Nothing is uninvoiced. Every closed period has been claimed by an invoice." |
*
* @param {Partner_Billing_Board_Alltime_NoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_alltime_none = /** @type {((inputs?: Partner_Billing_Board_Alltime_NoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Alltime_NoneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nichts ist offen. Jeder abgeschlossene Zeitraum wurde bereits einer Rechnung zugeordnet.")
	return /** @type {LocalizedString} */ ("Nothing is uninvoiced. Every closed period has been claimed by an invoice.")
});